import { render, staticRenderFns } from "./addadmin.vue?vue&type=template&id=99dbc452&"
import script from "./addadmin.vue?vue&type=script&lang=js&"
export * from "./addadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports